/* eslint-disable @typescript-eslint/no-explicit-any */
import './styles.scss';

import { FormikErrors, FormikTouched } from 'formik';
import React from 'react';

export const markAsError = ({ errors, touched, field }: ValidationErrorProps) =>
    typeof errors[field] === 'string' && touched[field] ? 'errorField' : '';

interface ValidationErrorProps {
    errors: FormikErrors<any>;
    touched: FormikTouched<any>;
    field: string;
    customMessage?: string;
    style?: React.CSSProperties;
}

export const ValidationError: React.FC<ValidationErrorProps> = ({ errors, touched, field, customMessage, style }) => (
    <>
        {typeof errors[field] === 'string' && touched[field] && (
            <div className="validationError">
                <span style={style} className="errorMessage">
                    {customMessage || errors[field]}
                </span>
            </div>
        )}
    </>
);
